import { observer } from 'mobx-react';
import * as React from 'react';
import { Task } from 'taskarian';
import { missingVarError, readVarT } from '../../Assertions/environments';
import { loadOneTrust } from './Loader';
import { handleOneTrustLoadError, OneTrustError } from './Types';

// Staging sets the key to an empty string while it tests Osano, so treat empty as missing.
const requireKey = (key: string): Task<OneTrustError, string> =>
  key === '' ? Task.fail(missingVarError('VITE_ONE_TRUST_KEY')) : Task.succeed(key);

class OneTrustTooling extends React.Component {
  componentDidMount() {
    Task.succeed<OneTrustError, string>('VITE_ONE_TRUST_KEY')
      .andThen(readVarT)
      .andThen(requireKey)
      .andThen(loadOneTrust)
      .fork(handleOneTrustLoadError, () => {
        console.log('OneTrust Loaded Successfully!', window.OneTrust);
      });
  }

  render() {
    return <></>;
  }
}

export default observer(OneTrustTooling);
